import Layout from "../../components/structure/layout";
import { motion } from "framer-motion";

const CookiePolicy = ({ siteConfig, storyBlok, language }) => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: { type: "tween", ease: "easeInOut", duration: 0.6 },
    },
  };

  return (
    <Layout siteConfig={siteConfig} storyBlok={storyBlok} forceDarkNav>
      <motion.div
        variants={fadeIn}
        initial="hidden"
        animate="show"
        className="bg-white min-h-screen"
      >
        <div className="mx-auto max-w-4xl px-6 py-16 lg:px-8 lg:py-24">
          <h1 className="font-lexend text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mb-10">
            Cookie Policy
          </h1>

          <div className="font-lexend text-sm leading-7 text-gray-700 space-y-8">
            <p>
              La presente Cookie Policy riguarda l'utilizzo di Cookie da parte
              del Sito web hydrotradesrl.it. Per la Privacy Policy del Sito web
              si può cliccare{" "}
              <a
                href="/privacy-policy"
                className="text-blue underline hover:opacity-80"
              >
                qui
              </a>
              .
            </p>
            <p>
              I Cookie sono piccoli file di testo di piccole dimensioni che
              possono essere utilizzati dai siti web per rendere più efficiente
              l'esperienza per l'Utente e che vengono inviate al suo browser,
              dove vengono memorizzati per essere poi ritrasmessi allo stesso
              Sito web alla sua successiva visita del medesimo. I Cookie hanno
              funzioni diverse.
            </p>
            <p>
              I Cookie hanno il fine di migliorare la funzionalità e la
              navigazione di questo Sito web. In altri casi, invece, i Cookie
              sono utilizzati per monitorare gli utenti durante la navigazione,
              che registrano informazioni su ciò che l'Utente compra o potrebbe
              voler comprare, per personalizzare la pubblicità che gli viene
              mostrata quando apre la mail o naviga su un social network e per
              personalizzare contenuti, fornire le funzioni dei social media e
              analizzare il traffico.
            </p>
            <p>
              Nel suo browser l'Utente può impostare le preferenze di Privacy in
              modo da non memorizzare Cookie, cancellarli dopo ogni visita o ogni
              volta che chiude il browser, o anche accettare solo i Cookie di
              hydrotradesrl.it e non quelli di terze parti.
            </p>

            <Section title="Cookie Tecnici">
              <p>
                I Cookie tecnici sono quelli il cui utilizzo non richiede il
                consenso dell'Utente. I Cookie tecnici sono utilizzati al solo
                fine di rendere possibile la navigazione dell'Utente sul Sito web
                e consentirgli di utilizzarne le funzionalità. Si tratta sempre di
                Cookie di prima parte, in quanto sono veicolati direttamente dal
                Titolare sul Sito web. I Cookie di navigazione sono normalmente
                Cookie di sessione e, pertanto, una volta chiuso il browser di
                navigazione, vengono disattivati automaticamente. Altri Cookie
                tecnici sono utili per consentire di memorizzare alcune preferenze
                dell'Utente senza doverle reimpostare nel corso delle visite
                successive (c.d. Cookie di Funzionalità). Per questo motivo, i
                Cookie di funzionalità sono spesso Cookie persistenti, in quanto
                rimangono memorizzati nel computer dell'Utente anche dopo la
                chiusura del browser di navigazione, fino alla data di scadenza
                per essi prevista o fino a quando l'Utente abbia deciso di
                eliminarli.
              </p>
            </Section>

            <Section title="Cookie di Terze parti">
              <p>
                Questi Cookie sono utilizzati al fine di raccogliere informazioni
                sull'utilizzo del Sito web fatto da parte degli Utenti in forma
                anonima quali: pagine visitate, tempo di permanenza, origini del
                traffico di provenienza, provenienza geografica, età, genere e
                interessi, ai fini statistici e di attività di marketing. Questi
                Cookie sono inviati da domini di terze parti esterni al Sito web.
              </p>
            </Section>

            <Section title="Chat Bot">
              <p>
                Questo sito web utilizza il servizio di Chat di:
              </p>
              <p className="mt-2">
                <strong>Facebook Messenger live chat</strong> — Per maggiori
                informazioni è sufficiente seguire questo link:{" "}
                <a
                  href="https://www.facebook.com/policies/cookies/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue underline hover:opacity-80"
                >
                  https://www.facebook.com/policies/cookies/
                </a>
              </p>
            </Section>

            <Section title="Protezione SPAM">
              <p>
                Questo sito web utilizza il servizio antispam.
              </p>
              <p className="mt-2">
                <strong>Akismet (Automattic Inc.)</strong> — Per maggiori
                informazioni è sufficiente seguire questo link:{" "}
                <a
                  href="https://automattic.com/privacy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue underline hover:opacity-80"
                >
                  https://automattic.com/privacy/
                </a>
              </p>
            </Section>

            <Section title="Statistica">
              <ul className="list-disc pl-6 space-y-4">
                <li>
                  <strong>Google Analytics</strong> — Google Analytics fa uso dei
                  Cookie per raccogliere informazioni, in forma aggregata, sul
                  numero degli Utenti e su come essi visitino questo Sito web.
                  Questo Sito web utilizza il servizio Google Analytics offerto da
                  Google Ireland Limited, con IP anonimizzato. Per ulteriori
                  informazioni:{" "}
                  <a
                    href="https://www.google.it/policies/privacy/partners/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    https://www.google.it/policies/privacy/partners/
                  </a>
                  <br />
                  È possibile disabilitare l'azione di Google Analytics attraverso
                  l'opt out:{" "}
                  <a
                    href="https://tools.google.com/dlpage/gaoptout"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    https://tools.google.com/dlpage/gaoptout
                  </a>
                </li>
                <li>
                  <strong>
                    Monitoraggio conversioni pixel di Facebook (Facebook Ireland
                    Ltd.)
                  </strong>{" "}
                  — Per maggiori informazioni:{" "}
                  <a
                    href="https://www.facebook.com/policies/cookies/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    https://www.facebook.com/policies/cookies/
                  </a>
                </li>
                <li>
                  <strong>Google Tag Manager (Google Ireland Limited)</strong> —
                  Per maggiori informazioni:{" "}
                  <a
                    href="https://policies.google.com/technologies/cookies?hl=it"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    https://policies.google.com/technologies/cookies?hl=it
                  </a>
                </li>
              </ul>
            </Section>

            <Section title="Pulsanti Social Network">
              <ul className="list-disc pl-6 space-y-3">
                <li>
                  <strong>Facebook</strong> — Per maggiori informazioni:{" "}
                  <a
                    href="https://www.facebook.com/policies/cookies/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    https://www.facebook.com/policies/cookies/
                  </a>
                </li>
                <li>
                  <strong>LinkedIn</strong> — Per maggiori informazioni:{" "}
                  <a
                    href="https://www.linkedin.com/legal/cookie-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    https://www.linkedin.com/legal/cookie-policy
                  </a>
                </li>
              </ul>
            </Section>

            <Section title="Contenuti su piattaforme esterne">
              <p>
                <strong>Google Font</strong> — Per maggiori informazioni:{" "}
                <a
                  href="https://policies.google.com/technologies/cookies?hl=it"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue underline hover:opacity-80"
                >
                  https://policies.google.com/technologies/cookies?hl=it
                </a>
              </p>
            </Section>

            <Section title="Cookie di profilazione">
              <p>
                I Cookie di profilazione sono utilizzati per creare un profilo di
                Utente, basato sulle preferenze ed i gusti da lui manifestati
                durante la navigazione su Internet, e fargli visualizzare
                messaggi pubblicitari coerenti con il suo profilo. In questo modo
                i messaggi pubblicitari che l'Utente visualizzerà su questo Sito
                web potranno essere per lui maggiormente interessanti. Come
                previsto dalla normativa vigente per l'installazione di tali
                Cookie è richiesto il preventivo consenso.
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-3">
                <li>
                  <strong>Facebook Pixel</strong> — Il Pixel di Facebook è
                  utilizzato per effettuare attività di "remarketing" e attività
                  di "retargeting"; grazie a queste attività si utilizzano i
                  Cookie che l'Utente lascia sul Sito web, senza identificarlo.
                  Per controllare e disabilitare le inserzioni:{" "}
                  <a
                    href="https://www.facebook.com/policies/cookies/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    https://www.facebook.com/policies/cookies/
                  </a>{" "}
                  e{" "}
                  <a
                    href="https://www.facebook.com/ads/settings"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    https://www.facebook.com/ads/settings
                  </a>
                </li>
                <li>
                  <strong>Google ADS</strong> — È possibile disabilitare
                  permanentemente le funzioni di targeting e di remarketing
                  disabilitando la funzione "pubblicità personalizzata"
                  nell'account Google:{" "}
                  <a
                    href="https://www.google.com/settings/ads/onweb/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    https://www.google.com/settings/ads/onweb/
                  </a>
                </li>
              </ul>
            </Section>

            <Section title="Eliminare o disattivare i Cookie">
              <p>
                Fatta eccezione per i Cookie tecnici strettamente necessari alla
                normale navigazione, il conferimento dei Dati è rimesso alla
                volontà dell'Utente che decide di navigare sul sito dopo aver
                preso visione dell'informativa breve contenuta nell'apposito
                banner e di usufruire dei servizi di terze parti che comportano
                l'installazione di Cookie. L'Utente può quindi evitare
                l'installazione dei Cookie mantenendo il banner o attraverso le
                apposite funzioni disponibili sul proprio browser o in questa
                policy. L'Utente può gestire le preferenze relative ai Cookie
                direttamente all'interno del suo browser ed impedire che terze
                parti possano installarne.
              </p>
              <p className="mt-3">
                È importante che l'Utente sappia che disabilitando tutti i Cookie,
                il funzionamento di questo Sito potrebbe essere compromesso.
              </p>
              <p className="mt-3">
                Ciascun browser presenta procedure diverse per la gestione delle
                impostazioni. L'Utente può ottenere istruzioni specifiche
                attraverso i link sottostanti:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>
                  <a
                    href="https://support.google.com/chrome/answer/2392971?hl=it-IT"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    Eliminare/disattivare i cookie Android
                  </a>
                </li>
                <li>
                  <a
                    href="http://support.mozilla.com/it/kb/Eliminare%20i%20cookie"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    Eliminare/disattivare i cookie di Mozilla Firefox
                  </a>
                </li>
                <li>
                  <a
                    href="http://windows.microsoft.com/it-IT/windows-vista/Delete-your-Internet-cookies"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    Eliminare/disattivare i cookie con Explorer
                  </a>
                </li>
                <li>
                  <a
                    href="http://support.google.com/chrome/bin/answer.py?hl=it&answer=95647"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    Eliminare/disattivare i cookie con Chrome
                  </a>
                </li>
                <li>
                  <a
                    href="http://support.apple.com/kb/PH5042"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    Eliminare/disattivare i cookie con Safari
                  </a>
                </li>
                <li>
                  <a
                    href="http://www.opera.com/browser/tutorials/security/privacy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    Eliminare/disattivare i cookie con Opera
                  </a>
                </li>
                <li>
                  <a
                    href="https://support.apple.com/it-it/HT201265"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue underline hover:opacity-80"
                  >
                    Eliminare/disattivare i cookie iOS
                  </a>
                </li>
              </ul>
              <p className="mt-4">
                Per disabilitare i Cookie di terze parti è inoltre possibile
                utilizzare{" "}
                <a
                  href="http://www.youronlinechoices.com/it/le-tue-scelte"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue underline hover:opacity-80"
                >
                  Your Online Choices
                </a>
                , un servizio web gestito dall'associazione non-profit European
                Interactive Digital Advertising Alliance (EDAA) che fornisce
                informazioni sulla pubblicità comportamentale basata sui Cookie di
                profilazione e consente agli utenti di opporsi facilmente
                (opt-out) alla loro installazione.
              </p>
            </Section>

            <Section title="Ulteriori informazioni sul trattamento">
              <p>
                Su richiesta dell'Utente, in aggiunta alle informazioni contenute
                in questa Cookie Policy, questo Sito web potrebbe fornire delle
                Informative aggiuntive e contestuali riguardanti servizi
                specifici, o la raccolta ed il trattamento di Dati Personali. Per
                necessità legate al funzionamento ed alla manutenzione, questo
                Sito e gli eventuali servizi terzi da esso utilizzati potrebbero
                raccogliere Log di sistema, ossia file che registrano le
                interazioni e che possono contenere anche Dati Personali.
                Maggiori informazioni in relazione al trattamento dei Dati
                Personali potranno essere richieste in qualsiasi momento al
                Titolare del Trattamento utilizzando le informazioni di contatto.
              </p>
            </Section>

            <Section title="Esercizio dei diritti dell'interessato">
              <p>
                Ai sensi degli artt. 15-22 del Regolamento Europeo n. 679/2016,
                l'Interessato ha diritto di ottenere la conferma dell'esistenza o
                meno di dati personali che lo riguardano, anche se non ancora
                registrati, e la loro comunicazione in forma intelligibile.
                L'interessato ha diritto di ottenere indicazione:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>a) dell'origine dei dati personali;</li>
                <li>b) delle finalità e modalità del trattamento;</li>
                <li>
                  c) della logica applicata in caso di trattamento effettuato con
                  l'ausilio di strumenti elettronici;
                </li>
                <li>
                  d) degli estremi identificativi del Titolare e dei Responsabili
                  del Trattamento dei Dati Personali;
                </li>
                <li>
                  e) dei soggetti o delle categorie di soggetti ai quali i Dati
                  Personali possono essere comunicati o che possono venirne a
                  conoscenza in qualità di rappresentante designato nel territorio
                  dello Stato, di responsabili o incaricati;
                </li>
                <li>
                  f) l'aggiornamento, la rettificazione ovvero, quando vi ha
                  interesse, l'integrazione dei Dati;
                </li>
                <li>
                  g) la cancellazione, la trasformazione in forma anonima o il
                  blocco dei dati trattati in violazione di legge, compresi quelli
                  di cui non è necessaria la conservazione in relazione agli scopi
                  per i quali i dati sono stati raccolti o successivamente
                  trattati.
                </li>
              </ul>
              <p className="mt-4">
                Il Titolare non è responsabile per l'aggiornamento di tutti i link
                visualizzabili nella presente Cookie Policy; pertanto, ogni
                qualvolta un link non sia funzionante e/o aggiornato, gli Utenti
                riconoscono ed accettano che dovranno sempre far riferimento al
                documento e/o sezione dei siti internet richiamati da tale link.
              </p>
            </Section>
          </div>
        </div>
      </motion.div>
    </Layout>
  );
};

const Section = ({ title, children }) => (
  <div>
    <h2 className="font-lexend text-lg font-semibold text-gray-900 mb-3">
      {title}
    </h2>
    {children}
  </div>
);

export default CookiePolicy;
